import React from 'react';
import PropTypes from 'prop-types';
import Media from 'react-media';
import { RenderField, ButtonV2, RenderTextareaField } from '@zola/zola-ui';
import { reduxForm, Field, propTypes as formProps } from 'redux-form';

import { TABLET_MAX, DESKTOP_MIN } from 'lib/responsive';

import ModalFullscreen from 'components/common/zolaUI/ModalFullscreen/ModalFullscreen';
import * as validations from 'components/common/form/commonValidations';
import { RenderDatePicker } from 'components/common/form/index';

import './ChecklistAddTask.less';

const ChecklistAddTask = ({ handleSubmit, valid, submitting, pristine, onClose }) => {
  const renderSaveButton = () => (
    <ButtonV2 onSubmit={handleSubmit} type="submit" disabled={!valid || pristine || submitting}>
      Save Task
    </ButtonV2>
  );

  const renderFormFields = () => (
    <div className="checklist-add-task__form">
      <Field
        name="title"
        id="title"
        type="text"
        label="Task Title"
        className="checklist-add-task__title"
        required
        autoFocus
        component={RenderField}
        placeholder="Give this task a name..."
        validate={[validations.MAX_LENGTH_100, validations.REQUIRED]}
      />
      <Field
        name="due_at"
        id="due-at"
        type="date"
        label="Due Date"
        className="checklist-add-task__due-date zola-ui render-field"
        required
        component={RenderDatePicker}
        hideFormGroup
        validate={[validations.REQUIRED, validations.DATE_AFTER_NOW, validations.DATE]}
        placeholder="MM/DD/YYYY"
        hideOnDayClick
      />
      <Field
        name="notes"
        id="notes"
        type="text"
        label="Notes"
        className="checklist-add-task__notes-input"
        component={RenderTextareaField}
        maxChars={1000}
        validate={[validations.MAX_LENGTH_1000]}
        placeholder="Add a note..."
        rows={3}
      />
    </div>
  );

  return (
    <div className="checklist-add-task__container">
      <form onSubmit={handleSubmit} autoComplete="off">
        <Media query={`(max-width: ${TABLET_MAX}px)`}>
          <ModalFullscreen
            headerTitle="Add a Task"
            onClose={onClose}
            footerContent={renderSaveButton()}
            className="checklist-add-task__fullScreenModal"
          >
            {renderFormFields()}
          </ModalFullscreen>
        </Media>
        <Media query={`(min-width: ${DESKTOP_MIN}px)`}>
          <div className="checklist-add-task__dropdown-container">
            <div className="checklist-add-task__header">
              <h2 className="checklist-add-task__header--title">Add a task</h2>
            </div>
            {renderFormFields()}
            {renderSaveButton()}
          </div>
        </Media>
      </form>
    </div>
  );
};

ChecklistAddTask.propTypes = {
  handleSubmit: PropTypes.func,
  onClose: PropTypes.func,
  ...formProps,
};

ChecklistAddTask.defaultProps = {};

const ChecklistAddTaskForm = reduxForm({
  form: 'checklistAddTaskForm',
})(ChecklistAddTask);

export default ChecklistAddTaskForm;



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistAddTask/ChecklistAddTask.jsx